import styled from 'styled-components';
import {dFlexColumn, dFlexStart} from '../../../../../globalVariables/GlobalFlex';
import {dFlexColumnAlineEnd} from '../../../../../globalVariables/GlobalFlex';

export const infoBanner = styled.div`
    ${dFlexColumnAlineEnd};
    gap: var(--space-xs);
    width: 100%;
    padding: var(--space-md) var(--space-lg);
    border-radius: var(--space-md);
    border: 1px solid var(--color-state-info-main);
    background: var(--color-state-info-bg);
`;

export const infoBannerInner = styled.div`
    ${dFlexStart};
    gap: var(--space-sm);
    width: 100%;
`;

export const infoBannerText = styled.div`
    ${dFlexColumn};
    gap: var(--space-xs);
    flex: 1;
    min-width: 0;
`;

export const infoBannerTitle = styled.p`
    margin: 0;
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-bold);
    line-height: 1.1;
    color: var(--color-text-default);
    text-align: start;
`;

export const infoBannerBody = styled.p`
    margin: 0;
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.1;
    color: var(--color-text-default);
    text-align: start;
`;
